// extracted by mini-css-extract-plugin
module.exports = {"mainPaper":"styles_mainPaper__25ARP","status":"styles_status__2t90t","row":"styles_row__2x8LY"};